export const ActionButtons = {
	Deatil: 1,
	Transactions: 2,
	Edit: 3,
	Delete: 4,
	TransactionApprove: 5,
	TransactionDecline: 6,
	Read: 7,
	Send: 8,
	ReportContractDonwload: 9,
	ReportSubjectDownload: 10,
	AECBErrorPopup: 11,
	BlogPreview: 12,
	LoanTransactionCancel: 13,
	PromoCodeActivate: 14,
	PromoCodeDeactivate: 15,
	AddMoney: 16,
	Confirm: 17,
	InvestorNote: 18,
	DepositTransactionCancel: 19,
	ResendVerificationEmail: 20,
};
